<template>
  <div class="p-4 flex flex-col items-center justify-center gap-4 min-h-full">
    <ContentEditRegenerateContent
      v-if="!contentPreview"
      :tones="toneOptions"
      :content-id="contentId"
      class="w-full"
      @compare="contentPreview = $event"
    />

    <div v-else>
      <p>{{ contentPreview }}</p>

      <div class="flex items-center gap-4 mt-6">
        <AppButton
          id="accept-generated-content"
          label="Accept"
          icon="pi pi-check"
          @click="emit('accept', contentPreview)"
        />
        <AppButton
          id="reject-regenerated-content"
          label="Decline"
          variant="secondary"
          icon="pi pi-times"
          @click="emit('cancel')"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import ContentEditRegenerateContent from "@/components/content/edit/regenerate/ContentEditRegenerateContent.vue";

const props = defineProps<{
  contentId: string;
  tone: string;
}>();

const emit = defineEmits<{
  cancel: [];
  accept: [string];
}>();

const contentPreview = ref("");

const toneOptions = computed(
  () =>
    props.tone
      ?.split(",")
      ?.map(tone => tone.trim())
      ?.filter(Boolean)
      ?.sort() ?? []
);
</script>
